module.exports = __webpack_public_path__ + "fonts/baronsans-medium-webfont.61e1f4a4.woff2";